import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import './Privacy.css';

function Privacy() {
  const { lang } = useParams();
  const currentLang = lang || 'en';
  const [privacyContent, setPrivacyContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const languages = {
    en: 'English',
    fr: 'Français',
    de: 'Deutsch',
    ru: 'Русский',
    'pt-br': 'Português (Brasil)',
    'zh-cn': '简体中文',
    ja: '日本語'
  };

  useEffect(() => {
    const filename = currentLang === 'en' ? 'privacy-policy.md' : `privacy-policy-${currentLang}.md`;
    fetch(`/${filename}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Privacy policy not found');
        }
        return response.text();
      })
      .then(text => {
        setPrivacyContent(text);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [currentLang]);

  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <div className="language-selector">
          {Object.entries(languages).map(([code, name]) => (
            <Link
              key={code}
              to={code === 'en' ? '/privacy' : `/privacy/${code}`}
              className={currentLang === code ? 'active' : ''}
            >
              {name}
            </Link>
          ))}
        </div>

        {loading && <p>Loading...</p>}

        {error && (
          <>
            <h1>Privacy Policy</h1>
            <p>Privacy policy content will be available soon.</p>
          </>
        )}

        {!loading && !error && <ReactMarkdown>{privacyContent}</ReactMarkdown>}
      </div>
    </div>
  );
}

export default Privacy;
